<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="submit">
      <dt-modal v-model="isVisible">
        <div slot="header">
          <h4 class="modal-title">
            Phone
          </h4>
        </div>
        <div slot="body">
          <contact-summary
            class="mb-4"
            :contact="value"
          />
          <div class="form-control custom-form">
            <dt-select
              v-model="phoneType"
              label="Phone Type"
              name="phoneType"
              :options="lookups['PhoneType']"
              validate="required"
            />
            <label for="PhoneNo">Phone #:</label>
            <span class="text-danger">*</span>
            <input
              class="form-control mb-3"
              name="PhoneNo"
              v-mask="/\(\d{3}\) \d{3}-\d{4}/"
              v-model="phoneNo"
              validate="required"
            >
            <dt-input
              v-model="extension"
              name="Extension"
              label="Extension"
              type="Number"
            />
            <dt-textarea
              v-model="phoneNote"
              name="PhoneNote"
              label="Notes"
            />
          </div>
        </div>
        <div slot="footer">
          <button
            type="button"
            class="btn btn-light"
            @click="close()"
          >Cancel</button>
          <button
            type="submit"
            class="btn btn-primary"
            @click="save()"
          >Save</button>
        </div>
      </dt-modal>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import mask from 'vue-r-mask'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import DtSelect from '@/components/utilities/form/dt-select'
import DtInput from '@/components/utilities/form/dt-input'
import DtTextarea from '@/components/utilities/form/dt-textarea'
import ContactSummary from '@/components/contacts/forms/contact-summary'
export default {
  name: 'contact-phone',
  components: {
    DtModal,
    DtSelect,
    DtInput,
    DtTextarea,
    ContactSummary
  },
  props: {
    value: {
      type: Object
    },
    phone: {
      type: Object,
      default() {
        return {
          contactPhone: 0,
          extension: '',
          isShared: false,
          isPrimary: false,
          phone: 0,
          phoneNo: '',
          phoneNote: '',
          phoneType: 0,
          phoneTypeName: '',
          primary: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    phoneType: {
      get() {
        return this.phone !== null ? this.phone.phoneType : 0
      },
      set(value) {
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'phoneType',
          value: parseInt(value)
        })
      }
    },
    phoneNo: {
      get() {
        return this.phone !== null ? this.phone.phoneNo : ''
      },
      set(value) {
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'phoneNo',
          value: value
        })
      }
    },
    extension: {
      get() {
        return this.phone !== null ? this.phone.extension : ''
      },
      set(value) {
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'extension',
          value: value
        })
      }
    },
    phoneNote: {
      get() {
        return this.phone !== null ? this.phone.phoneNote : ''
      },
      set(value) {
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'phoneNote',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['setItem', 'removePhone']),
    close() {
      if (this.phone.contactPhone === -1) {
        this.removePhone(-1)
      }
      this.$emit('closing')
    },
    async save() {
      this.$refs.form.validate().then(async success => {
        if (success) {
          this.$emit('send', this.phone.contactPhone)
        }
      })
    },
    submit() {}
  },
  directives: {
    mask: mask
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  text-align: left;
  max-height: 250px;
  height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/phone.vue